import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import FlexCenteredStyle from '@sdk/components/ui/FlexCenteredStyle';
import Clickable from '@sdk/components/primitives/Clickable';

export const Container = styled(Column)`
  flex-grow: 1;
  overflow: hidden;
`;

export const RelativeContainer = styled(Row)`
  position: relative;
  ${FlexCenteredStyle};
`;

export const SearchIcon = styled(Row)`
  position: absolute;
  left: 0;
  height: 36px;
  ${FlexCenteredStyle};
`;

export const GifsContainer = styled(Row)`
  height: 215px;
  flex-grow: 1;
  margin-top: 10px;
  overflow-x: scroll;
`;

export const GifImage = styled.img``;

export const GifImageOverlay = styled(Row)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  ${FlexCenteredStyle};
  background-color: ${({ theme }): string => theme.colors.modalBgOverlay};
  display: none;
`;

export const GifImageContainer = styled(Clickable)`
  margin-right: 10px;
  position: relative;
  &:hover ${GifImageOverlay} {
    display: flex;
  }
`;

export const GiphyLogo = styled.img`
  height: auto;
  width: 150px;
`;

export const CenteredColumn = styled(Column)`
  ${FlexCenteredStyle};
`;

export const ClearIcon = styled(Row)`
  position: absolute;
  right: 0;
`;
